import { Component, Input } from '@angular/core';
import { WidgetResolver } from 'app/views/presentations/widgets/widgetResolver';

@Component({
    selector: 'psm-widget-button',
    templateUrl: 'widgetButton.component.html'
})
export class WidgetButtonComponent {

    @Input() public showText = true;
    public nameResourceKey: string;
    public icon: string;

    private _type: string;
    public get type() { return this._type; }
    @Input() public set type(type: string) {
        this._type = type;
        this.updateWidget();
    }

    constructor(private resolver: WidgetResolver) {
    }

    private updateWidget() {
        if (this.type) {
            const widget = this.resolver.resolveComponentMetadata(this.type);
            this.nameResourceKey = widget.nameResourceKey;
            this.icon = widget.icon;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/widgetButton.component.ts